const Cancel = function () {
  this.addStore.hideModal()
  this.addStore.resetAddStoreModal()
}

export default Cancel
